var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCategoryProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 104",
    d: "M1 1.33983V21.7C1 21.8657 1.13431 22 1.3 22H21.2C21.3657 22 21.5 21.8657 21.5 21.7V11.2668C21.5 11.1146 21.3861 10.9866 21.2351 10.9688L13.2649 10.0312C13.1139 10.0134 13 9.88535 13 9.73322V2.76483C13 2.61354 12.8873 2.48592 12.7372 2.46715L1.33721 1.04215C1.15815 1.01977 1 1.15939 1 1.33983Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 105",
    d: "M5 4V6",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 108",
    d: "M5 8V10",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 115",
    d: "M15 12V20",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 118",
    d: "M13 9V22",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 116",
    d: "M17 13V20",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 117",
    d: "M19 14V20",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 111",
    d: "M5 12V14",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 106",
    d: "M7 4V6",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 109",
    d: "M7 8V10",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 112",
    d: "M7 12V14",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 107",
    d: "M9 4V6",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 110",
    d: "M9 8V10",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 113",
    d: "M9 12V14",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 114",
    d: "M4.9987 21.5029C4.9987 21.5029 4.99723 18.505 4.9987 16.5029C5.00017 14.5008 9 14.5 8.9987 16.5029C8.9974 18.5059 8.9987 21.5029 8.9987 21.5029",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCategoryProperty);
export default __webpack_public_path__ + "static/media/project-category-property.9dac53ea.svg";
export { ForwardRef as ReactComponent };